import Header from "./Header";
import React from "react";
import Footer from "./Footer";

export const Datenschutz = () => {
    return (
        <div className="justify-center">
            <div className="mx-auto">
                <div className="intro">
                    <Header/>
                    {/*<Intro/>*/}
                </div>
            </div>
            <div className="p-5 max-w-5xl rounded-lg shadow-lg">
                <h1 className="text-2xl font-bold text-white-800 mb-4">Datenschutzerklärung</h1>

                <div className="mb-6">
                    <h1 className="text-2xl font-bold text-gray-800 mb-4">1. Datenerfassung auf dieser Website</h1>

                    <h2 className="text-xl font-semibold text-gray-800 mb-4">
                        Wer ist verantwortlich für die Datenerfassung auf dieser Website?
                    </h2>
                    <p className="text-lg font-semibold text-gray-700 mb-4">
                        Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen Kontaktdaten
                        können Sie dem Abschnitt „Hinweis zur Verantwortlichen Stelle“ in dieser Datenschutzerklärung
                        entnehmen.
                    </p>

                    <h2 className="text-xl font-semibold text-gray-800 mb-4">
                        Wie erfassen wir Ihre Daten?
                    </h2>
                    <p className="text-lg font-semibold text-gray-700 mb-4">
                        Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. Hierbei kann es sich
                        z. B. um Daten handeln, die Sie in ein Kontaktformular eingeben.
                    </p>
                    <p className="text-lg font-semibold text-gray-700 mb-4">
                        Andere Daten werden automatisch oder nach Ihrer Einwilligung beim Besuch der Website durch
                        unsere
                        IT-Systeme erfasst. Das sind vor allem technische Daten (z. B. Internetbrowser, Betriebssystem
                        oder Uhrzeit des Seitenaufrufs). Die Erfassung dieser Daten erfolgt automatisch, sobald Sie
                        diese
                        Website betreten.
                    </p>

                    <h2 className="text-xl font-semibold text-gray-800 mb-4">
                        Wofür nutzen wir Ihre Daten?
                    </h2>
                    <p className="text-lg font-semibold text-gray-700 mb-4">
                        Ein Teil der Daten wird erhoben, um eine fehlerfreie Bereitstellung der Website zu
                        gewährleisten.
                        Andere Daten können zur Analyse Ihres Nutzerverhaltens verwendet werden. Sofern über die Website
                        Verträge geschlossen oder angebahnt werden können, werden die übermittelten Daten auch für
                        Vertragsangebote, Bestellungen oder sonstige Auftragsanfragen verarbeitet.
                    </p>

                    <h2 className="text-xl font-semibold text-gray-800 mb-4">
                        Welche Rechte haben Sie bezüglich Ihrer Daten?
                    </h2>
                    <p className="text-lg font-semibold text-gray-700 mb-4">
                        Sie haben jederzeit das Recht, unentgeltlich Auskunft über Herkunft, Empfänger und Zweck
                        Ihrer gespeicherten personenbezogenen Daten zu erhalten. Sie haben außerdem ein Recht,
                        die Berichtigung oder Löschung dieser Daten zu verlangen. Wenn Sie eine Einwilligung zur
                        Datenverarbeitung erteilt haben, können Sie diese Einwilligung jederzeit für die Zukunft
                        widerrufen. Außerdem haben Sie das Recht, unter bestimmten Umständen die Einschränkung der
                        Verarbeitung Ihrer personenbezogenen Daten zu verlangen. Des Weiteren steht Ihnen ein
                        Beschwerderecht bei der zuständigen Aufsichtsbehörde zu.
                    </p>
                    <p className="text-lg font-semibold text-gray-700 mb-4">
                        Hierzu sowie zu weiteren Fragen zum Thema Datenschutz können Sie sich jederzeit an uns wenden.
                    </p>
                </div>

                <div className="mb-6">
                    <h1 className="text-2xl font-bold text-gray-800 mb-4">2. Hosting</h1>
                    <p className="text-lg font-semibold text-gray-700 mb-4">
                        Wir hosten die Inhalte unserer Website bei folgendem Anbieter:
                    </p>
                    <p className="text-lg font-semibold text-gray-700 mb-4">
                        <strong>Amazon Web Services (AWS)</strong><br/>
                        Anbieter ist die Amazon Web Services EMEA SARL, 38 Avenue John F. Kennedy, 1855 Luxemburg
                        (nachfolgend AWS).
                    </p>
                    <p className="text-lg font-semibold text-gray-700 mb-4">
                        Wenn Sie unsere Website besuchen, werden Ihre personenbezogenen Daten auf den Servern von AWS
                        verarbeitet. Hierbei können auch personenbezogene Daten an das Mutterunternehmen von AWS in die
                        USA
                        übermittelt werden. Die Datenübertragung in die USA wird auf die EU-Standardvertragsklauseln
                        gestützt. Details finden Sie hier:<br/>
                        <a
                            href="https://aws.amazon.com/de/blogs/security/aws-gdpr-data-processing-addendum/"
                            className="text-blue-600 underline"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            https://aws.amazon.com/de/blogs/security/aws-gdpr-data-processing-addendum/
                        </a>.
                    </p>
                    <p className="text-lg font-semibold text-gray-700 mb-4">
                        Weitere Informationen entnehmen Sie der Datenschutzerklärung von AWS:<br/>
                        <a
                            href="https://aws.amazon.com/de/privacy/?nc1=f_pr"
                            className="text-blue-600 underline"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            https://aws.amazon.com/de/privacy/?nc1=f_pr
                        </a>.
                    </p>
                    <p className="text-lg font-semibold text-gray-700 mb-4">
                        Die Verwendung von AWS erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Wir haben ein
                        berechtigtes Interesse an einer möglichst zuverlässigen Darstellung unserer Website. Sofern eine
                        entsprechende Einwilligung abgefragt wurde, erfolgt die Verarbeitung ausschließlich auf
                        Grundlage
                        von Art. 6 Abs. 1 lit. a DSGVO und § 25 Abs. 1 TDDDG, soweit die Einwilligung die Speicherung
                        von
                        Cookies oder den Zugriff auf Informationen im Endgerät des Nutzers (z. B. Device-Fingerprinting)
                        im Sinne des TDDDG umfasst. Die Einwilligung ist jederzeit widerrufbar.
                    </p>
                    <p className="text-lg font-semibold text-gray-700 mb-4">
                        Das Unternehmen verfügt über eine Zertifizierung nach dem „EU-US Data Privacy Framework“ (DPF).
                        Der DPF ist ein Übereinkommen zwischen der Europäischen Union und den USA, der die Einhaltung
                        europäischer Datenschutzstandards bei Datenverarbeitungen in den USA gewährleisten soll. Jedes
                        nach dem DPF zertifizierte Unternehmen verpflichtet sich, diese Datenschutzstandards
                        einzuhalten.
                        Weitere Informationen hierzu erhalten Sie vom Anbieter unter folgendem Link:<br/>
                        <a
                            href="https://www.dataprivacyframework.gov/participant/5776"
                            className="text-blue-600 underline"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            https://www.dataprivacyframework.gov/participant/5776
                        </a>.
                    </p>
                    <p className="text-lg font-semibold text-gray-700 mb-4">
                        <strong>Auftragsverarbeitung</strong><br/>
                        Wir haben einen Vertrag über Auftragsverarbeitung (AVV) zur Nutzung des oben genannten Dienstes
                        geschlossen. Hierbei handelt es sich um einen datenschutzrechtlich vorgeschriebenen Vertrag, der
                        gewährleistet, dass dieser die personenbezogenen Daten unserer Websitebesucher nur nach unseren
                        Weisungen und unter Einhaltung der DSGVO verarbeitet.
                    </p>
                    <p className="text-lg font-bold text-gray-800 mb-4">AWS CloudFront</p>

                    <p className="text-lg font-semibold text-gray-800 mb-4">Art und Umfang der Verarbeitung</p>
                    <p className="text-lg font-semibold text-gray-700 mb-4">
                        Wir verwenden zur ordnungsgemäßen Bereitstellung der Inhalte unserer Website AWS CloudFront. AWS
                        CloudFront ist
                        ein Dienst der Amazon Web Services, Inc., welcher auf unserer Website als Content Delivery
                        Network (CDN) fungiert.
                    </p>
                    <p className="text-lg font-semibold text-gray-700 mb-4">
                        Ein CDN trägt dazu bei, Inhalte unseres Onlineangebotes, insbesondere Dateien wie Grafiken oder
                        Skripte, mit Hilfe
                        regional oder international verteilter Server schneller bereitzustellen. Wenn Sie auf diese
                        Inhalte zugreifen,
                        stellen Sie eine Verbindung zu Servern der Amazon Web Services, Inc. her, wobei Ihre IP-Adresse
                        und ggf.
                        Browserdaten wie Ihr User-Agent übermittelt werden. Diese Daten werden ausschließlich zu den
                        oben genannten
                        Zwecken und zur Aufrechterhaltung der Sicherheit und Funktionalität von AWS CloudFront
                        verarbeitet.
                    </p>

                    <h2 className="text-lg font-semibold text-gray-800 mb-4">Zweck und Rechtsgrundlage</h2>
                    <p className="text-lg font-semibold text-gray-700 mb-4">
                        Die Nutzung des Content Delivery Networks erfolgt auf Grundlage unserer berechtigten Interessen,
                        d.h. Interesse
                        an einer sicheren und effizienten Bereitstellung sowie der Optimierung unseres Onlineangebotes
                        gemäß
                        Art. 6 Abs. 1 lit. f DSGVO.
                    </p>

                    <h2 className="text-lg font-semibold text-gray-800 mb-4">Speicherdauer</h2>
                    <p className="text-lg font-semibold text-gray-700 mb-4">
                        Die konkrete Speicherdauer der verarbeiteten Daten ist nicht durch uns beeinflussbar, sondern
                        wird von
                        Amazon Web Services, Inc. bestimmt. Weitere Hinweise finden Sie in der Datenschutzerklärung für
                        AWS CloudFront:
                        <a
                            href="https://aws.amazon.com/de/privacy/"
                            className="text-blue-600 underline"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            https://aws.amazon.com/de/privacy/
                        </a>.
                    </p>
                </div>

                <div className="mb-6">
                    <h1 className="text-2xl font-bold text-gray-800 mb-4">3. Allgemeine Hinweise und
                        Pflichtinformationen</h1>

                    <h2 className="text-xl font-semibold text-gray-800 mb-4">Datenschutz</h2>
                    <p className="text-lg font-semibold text-gray-700 mb-4">
                        Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Wir behandeln
                        Ihre personenbezogenen Daten vertraulich und entsprechend den gesetzlichen
                        Datenschutzvorschriften
                        sowie dieser Datenschutzerklärung.
                    </p>
                    <p className="text-lg font-semibold text-gray-700 mb-4">
                        Wenn Sie diese Website benutzen, werden verschiedene personenbezogene Daten erhoben.
                        Personenbezogene Daten sind Daten, mit denen Sie persönlich identifiziert werden können.
                        Die vorliegende Datenschutzerklärung erläutert, welche Daten wir erheben und wofür wir sie
                        nutzen.
                        Sie erläutert auch, wie und zu welchem Zweck das geschieht.
                    </p>
                    <p className="text-lg font-semibold text-gray-700 mb-4">
                        Wir weisen darauf hin, dass die Datenübertragung im Internet (z. B. bei der Kommunikation per
                        E-Mail) Sicherheitslücken aufweisen kann. Ein lückenloser Schutz der Daten vor dem Zugriff durch
                        Dritte ist nicht möglich.
                    </p>

                    <h2 className="text-xl font-semibold text-gray-800 mb-4">Hinweis zur verantwortlichen Stelle</h2>
                    <p className="text-lg font-semibold text-gray-700 mb-4">
                        Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:<br/><br/>
                        <strong>ubion GmbH</strong><br/>
                        Uhdestraße 25<br/>
                        08056 Zwickau<br/>
                        Deutschland<br/>
                        Telefon: +49 375 27 21 97 70<br/>
                        E-Mail: info@ubi-on.com
                    </p>
                    <p className="text-lg font-semibold text-gray-700 mb-4">
                        Verantwortliche Stelle ist die natürliche oder juristische Person, die allein oder gemeinsam
                        mit anderen über die Zwecke und Mittel der Verarbeitung von personenbezogenen Daten
                        (z. B. Namen, E-Mail-Adressen o. Ä.) entscheidet.
                    </p>

                    <h2 className="text-xl font-semibold text-gray-800 mb-4">Speicherdauer</h2>
                    <p className="text-lg font-semibold text-gray-700 mb-4">
                        Soweit innerhalb dieser Datenschutzerklärung keine speziellere Speicherdauer genannt wurde,
                        verbleiben Ihre personenbezogenen Daten bei uns, bis der Zweck für die Datenverarbeitung
                        entfällt.
                        Wenn Sie ein berechtigtes Löschersuchen geltend machen oder eine Einwilligung zur
                        Datenverarbeitung
                        widerrufen, werden Ihre Daten gelöscht, sofern wir keine anderen rechtlich zulässigen Gründe für
                        die
                        Speicherung Ihrer personenbezogenen Daten haben (z. B. steuer- oder handelsrechtliche
                        Aufbewahrungsfristen); im letztgenannten Fall erfolgt die Löschung nach Fortfall dieser Gründe.
                    </p>

                    <h2 className="text-xl font-semibold text-gray-800 mb-4">
                        Allgemeine Hinweise zu den Rechtsgrundlagen der Datenverarbeitung auf dieser Website
                    </h2>
                    <p className="text-lg font-semibold text-gray-700 mb-4">
                        Sofern Sie in die Datenverarbeitung eingewilligt haben, verarbeiten wir Ihre personenbezogenen
                        Daten
                        auf Grundlage von Art. 6 Abs. 1 lit. a DSGVO bzw. Art. 9 Abs. 2 lit. a DSGVO, sofern besondere
                        Datenkategorien nach Art. 9 Abs. 1 DSGVO verarbeitet werden. Im Falle einer ausdrücklichen
                        Einwilligung in die Übertragung personenbezogener Daten in Drittstaaten erfolgt die
                        Datenverarbeitung
                        außerdem auf Grundlage von Art. 49 Abs. 1 lit. a DSGVO. Sofern Sie in die Speicherung von
                        Cookies oder
                        in den Zugriff auf Informationen in Ihr Endgerät (z. B. via Device-Fingerprinting) eingewilligt
                        haben,
                        erfolgt die Datenverarbeitung zusätzlich auf Grundlage von § 25 Abs. 1 TDDDG. Die Einwilligung
                        ist
                        jederzeit widerrufbar. Sind Ihre Daten zur Vertragserfüllung oder zur Durchführung
                        vorvertraglicher
                        Maßnahmen erforderlich, verarbeiten wir Ihre Daten auf Grundlage des Art. 6 Abs. 1 lit. b DSGVO.
                        Des Weiteren verarbeiten wir Ihre Daten, sofern diese zur Erfüllung einer rechtlichen
                        Verpflichtung
                        erforderlich sind, auf Grundlage von Art. 6 Abs. 1 lit. c DSGVO. Die Datenverarbeitung kann
                        ferner
                        auf Grundlage unseres berechtigten Interesses nach Art. 6 Abs. 1 lit. f DSGVO erfolgen. Über die
                        jeweils im Einzelfall einschlägigen Rechtsgrundlagen wird in den folgenden Absätzen dieser
                        Datenschutzerklärung informiert.
                    </p>

                    <h2 className="text-xl font-semibold text-gray-800 mb-4">Empfänger von personenbezogenen Daten</h2>
                    <p className="text-lg font-semibold text-gray-700 mb-4">
                        Im Rahmen unserer Geschäftstätigkeit arbeiten wir mit verschiedenen externen Stellen zusammen.
                        Dabei ist teilweise auch eine Übermittlung von personenbezogenen Daten an diese externen Stellen
                        erforderlich. Wir geben personenbezogene Daten nur dann an externe Stellen weiter, wenn dies im
                        Rahmen einer Vertragserfüllung erforderlich ist, wenn wir gesetzlich hierzu verpflichtet sind
                        (z. B. Weitergabe von Daten an Steuerbehörden), wenn wir ein berechtigtes Interesse nach Art. 6
                        Abs. 1
                        lit. f DSGVO an der Weitergabe haben oder wenn eine sonstige Rechtsgrundlage die Datenweitergabe
                        erlaubt. Beim Einsatz von Auftragsverarbeitern geben wir personenbezogene Daten unserer Kunden
                        nur
                        auf Grundlage eines gültigen Vertrags über Auftragsverarbeitung weiter. Im Falle einer
                        gemeinsamen
                        Verarbeitung wird ein Vertrag über gemeinsame Verarbeitung geschlossen.
                    </p>

                    <h2 className="text-xl font-semibold text-gray-800 mb-4">
                        Widerruf Ihrer Einwilligung zur Datenverarbeitung
                    </h2>
                    <p className="text-lg font-semibold text-gray-700 mb-4">
                        Viele Datenverarbeitungsvorgänge sind nur mit Ihrer ausdrücklichen Einwilligung möglich. Sie
                        können
                        eine bereits erteilte Einwilligung jederzeit widerrufen. Die Rechtmäßigkeit der bis zum Widerruf
                        erfolgten Datenverarbeitung bleibt vom Widerruf unberührt.
                    </p>

                    <h2 className="text-xl font-semibold text-gray-800 mb-4">
                        Widerspruchsrecht gegen die Datenerhebung in besonderen Fällen sowie gegen Direktwerbung (Art.
                        21 DSGVO)
                    </h2>
                    <p className="text-lg font-semibold text-gray-700 mb-4">
                        WENN DIE DATENVERARBEITUNG AUF GRUNDLAGE VON ART. 6 ABS. 1 LIT. E ODER F DSGVO ERFOLGT,
                        HABEN SIE JEDERZEIT DAS RECHT, AUS GRÜNDEN, DIE SICH AUS IHRER BESONDEREN SITUATION ERGEBEN,
                        GEGEN DIE VERARBEITUNG IHRER PERSONENBEZOGENEN DATEN WIDERSPRUCH EINZULEGEN; DIES GILT AUCH FÜR
                        EIN AUF DIESE BESTIMMUNGEN GESTÜTZTES PROFILING. DIE JEWEILIGE RECHTSGRUNDLAGE, AUF DENEN EINE
                        VERARBEITUNG BERUHT, ENTNEHMEN SIE DIESER DATENSCHUTZERKLÄRUNG. WENN SIE WIDERSPRUCH EINLEGEN,
                        WERDEN WIR IHRE BETROFFENEN PERSONENBEZOGENEN DATEN NICHT MEHR VERARBEITEN, ES SEI DENN, WIR
                        KÖNNEN ZWINGENDE SCHUTZWÜRDIGE GRÜNDE FÜR DIE VERARBEITUNG NACHWEISEN, DIE IHRE INTERESSEN,
                        RECHTE UND FREIHEITEN ÜBERWIEGEN ODER DIE VERARBEITUNG DIENT DER GELTENDMACHUNG, AUSÜBUNG ODER
                        VERTEIDIGUNG VON RECHTSANSPRÜCHEN (WIDERSPRUCH NACH ART. 21 ABS. 1 DSGVO).
                    </p>
                    <p className="text-lg font-semibold text-gray-700 mb-4">
                        WERDEN IHRE PERSONENBEZOGENEN DATEN VERARBEITET, UM DIREKTWERBUNG ZU BETREIBEN, SO HABEN SIE
                        DAS RECHT, JEDERZEIT WIDERSPRUCH GEGEN DIE VERARBEITUNG SIE BETREFFENDER PERSONENBEZOGENER
                        DATEN ZUM ZWECKE DERARTIGER WERBUNG EINZULEGEN; DIES GILT AUCH FÜR DAS PROFILING, SOWEIT ES
                        MIT SOLCHER DIREKTWERBUNG IN VERBINDUNG STEHT. WENN SIE WIDERSPRECHEN, WERDEN IHRE
                        PERSONENBEZOGENEN DATEN ANSCHLIESSEND NICHT MEHR ZUM ZWECKE DER DIREKTWERBUNG VERWENDET
                        (WIDERSPRUCH NACH ART. 21 ABS. 2 DSGVO).
                    </p>

                    <h2 className="text-xl font-semibold text-gray-800 mb-4">Beschwerderecht bei der zuständigen
                        Aufsichtsbehörde</h2>
                    <p className="text-lg font-semibold text-gray-700 mb-4">
                        Im Falle von Verstößen gegen die DSGVO steht den Betroffenen ein Beschwerderecht bei einer
                        Aufsichtsbehörde, insbesondere in dem Mitgliedstaat ihres gewöhnlichen Aufenthalts, ihres
                        Arbeitsplatzes oder des Orts des mutmaßlichen Verstoßes zu. Das Beschwerderecht besteht
                        unbeschadet anderweitiger verwaltungsrechtlicher oder gerichtlicher Rechtsbehelfe.
                    </p>

                    <h2 className="text-xl font-semibold text-gray-800 mb-4">Recht auf Datenübertragbarkeit</h2>
                    <p className="text-lg font-semibold text-gray-700 mb-4">
                        Sie haben das Recht, Daten, die wir auf Grundlage Ihrer Einwilligung oder in Erfüllung eines
                        Vertrags automatisiert verarbeiten, an sich oder an einen Dritten in einem gängigen,
                        maschinenlesbaren Format aushändigen zu lassen. Sofern Sie die direkte Übertragung der Daten
                        an einen anderen Verantwortlichen verlangen, erfolgt dies nur, soweit es technisch machbar ist.
                    </p>

                    <h2 className="text-xl font-semibold text-gray-800 mb-4">Auskunft, Berichtigung und Löschung</h2>
                    <p className="text-lg font-semibold text-gray-700 mb-4">
                        Sie haben im Rahmen der geltenden gesetzlichen Bestimmungen jederzeit das Recht auf
                        unentgeltliche Auskunft über Ihre gespeicherten personenbezogenen Daten, deren Herkunft und
                        Empfänger und den Zweck der Datenverarbeitung und ggf. ein Recht auf Berichtigung oder Löschung
                        dieser Daten. Hierzu sowie zu weiteren Fragen zum Thema personenbezogene Daten können Sie sich
                        jederzeit an uns wenden.
                    </p>

                    <h2 className="text-xl font-semibold text-gray-800 mb-4">Recht auf Einschränkung der
                        Verarbeitung</h2>
                    <p className="text-lg font-semibold text-gray-700 mb-4">
                        Sie haben das Recht, die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu
                        verlangen.
                        Hierzu können Sie sich jederzeit an uns wenden. Das Recht auf Einschränkung der Verarbeitung
                        besteht in folgenden Fällen:
                    </p>
                    <ul className="list-disc list-inside text-lg font-semibold text-gray-700 mb-4">
                        <li>
                            Wenn Sie die Richtigkeit Ihrer bei uns gespeicherten personenbezogenen Daten bestreiten,
                            benötigen wir in der Regel Zeit, um dies zu überprüfen. Für die Dauer der Prüfung haben Sie
                            das
                            Recht, die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen.
                        </li>
                        <li>
                            Wenn die Verarbeitung Ihrer personenbezogenen Daten unrechtmäßig geschah/geschieht, können
                            Sie
                            statt der Löschung die Einschränkung der Datenverarbeitung verlangen.
                        </li>
                        <li>
                            Wenn wir Ihre personenbezogenen Daten nicht mehr benötigen, Sie sie jedoch zur Ausübung,
                            Verteidigung oder Geltendmachung von Rechtsansprüchen benötigen, haben Sie das Recht, statt
                            der
                            Löschung die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen.
                        </li>
                        <li>
                            Wenn Sie einen Widerspruch nach Art. 21 Abs. 1 DSGVO eingelegt haben, muss eine Abwägung
                            zwischen Ihren und unseren Interessen vorgenommen werden. Solange noch nicht feststeht,
                            wessen Interessen überwiegen, haben Sie das Recht, die Einschränkung der Verarbeitung Ihrer
                            personenbezogenen Daten zu verlangen.
                        </li>
                    </ul>
                    <p className="text-lg font-semibold text-gray-700 mb-4">
                        Wenn Sie die Verarbeitung Ihrer personenbezogenen Daten eingeschränkt haben, dürfen diese Daten
                        –
                        von ihrer Speicherung abgesehen – nur mit Ihrer Einwilligung oder zur Geltendmachung, Ausübung
                        oder
                        Verteidigung von Rechtsansprüchen oder zum Schutz der Rechte einer anderen natürlichen oder
                        juristischen Person oder aus Gründen eines wichtigen öffentlichen Interesses der Europäischen
                        Union oder eines Mitgliedstaats verarbeitet werden.
                    </p>

                    <h2 className="text-xl font-semibold text-gray-800 mb-4">SSL- bzw. TLS-Verschlüsselung</h2>
                    <p className="text-lg font-semibold text-gray-700 mb-4">
                        Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der Übertragung vertraulicher Inhalte,
                        wie zum Beispiel Bestellungen oder Anfragen, die Sie an uns als Seitenbetreiber senden, eine
                        SSL-
                        bzw. TLS-Verschlüsselung. Eine verschlüsselte Verbindung erkennen Sie daran, dass die
                        Adresszeile
                        des Browsers von „http://“ auf „https://“ wechselt und an dem Schloss-Symbol in Ihrer
                        Browserzeile.
                    </p>
                    <p className="text-lg font-semibold text-gray-700 mb-4">
                        Wenn die SSL- bzw. TLS-Verschlüsselung aktiviert ist, können die Daten, die Sie an uns
                        übermitteln,
                        nicht von Dritten mitgelesen werden.
                    </p>
                </div>

                <div className="mb-6">
                    <h1 className="text-2xl font-bold text-gray-800 mb-4">Präsenzen in sozialen Netzwerken (Social
                        Media)</h1>

                    <p className="text-lg font-semibold text-gray-700 mb-4">
                        Wir unterhalten Onlinepräsenzen innerhalb sozialer Netzwerke und verarbeiten in diesem Rahmen
                        Daten der Nutzer,
                        um mit den dort aktiven Nutzern zu kommunizieren oder um Informationen über uns anzubieten.
                    </p>
                    <p className="text-lg font-semibold text-gray-700 mb-4">
                        Wir weisen darauf hin, dass dabei Daten der Nutzer außerhalb des Raumes der Europäischen Union
                        verarbeitet werden können.
                        Hierdurch können sich für die Nutzer Risiken ergeben, weil so z. B. die Durchsetzung der Rechte
                        der Nutzer erschwert werden könnte.
                    </p>
                    <p className="text-lg font-semibold text-gray-700 mb-4">
                        Ferner werden die Daten der Nutzer innerhalb sozialer Netzwerke im Regelfall für
                        Marktforschungs- und Werbezwecke verarbeitet.
                        So können z. B. anhand des Nutzungsverhaltens und sich daraus ergebender Interessen der Nutzer
                        Nutzungsprofile erstellt werden.
                        Die Nutzungsprofile können wiederum verwendet werden, um z. B. Werbeanzeigen innerhalb und
                        außerhalb der Netzwerke zu schalten,
                        die mutmaßlich den Interessen der Nutzer entsprechen. Zu diesen Zwecken werden im Regelfall
                        Cookies auf den Rechnern der Nutzer gespeichert,
                        in denen das Nutzungsverhalten und die Interessen der Nutzer gespeichert werden. Ferner können
                        in den Nutzungsprofilen auch Daten
                        unabhängig der von den Nutzern verwendeten Geräte gespeichert werden (insbesondere, wenn die
                        Nutzer Mitglieder der jeweiligen
                        Plattformen sind und bei diesen eingeloggt sind).
                    </p>
                    <p className="text-lg font-semibold text-gray-700 mb-4">
                        Für eine detaillierte Darstellung der jeweiligen Verarbeitungsformen und der
                        Widerspruchsmöglichkeiten (Opt-Out)
                        verweisen wir auf die Datenschutzerklärungen und Angaben der Betreiber der jeweiligen Netzwerke.
                    </p>
                    <p className="text-lg font-semibold text-gray-700 mb-4">
                        Auch im Fall von Auskunftsanfragen und der Geltendmachung von Betroffenenrechten weisen wir
                        darauf hin,
                        dass diese am effektivsten bei den Anbietern geltend gemacht werden können. Nur die Anbieter
                        haben jeweils Zugriff auf die Daten der Nutzer
                        und können direkt entsprechende Maßnahmen ergreifen und Auskünfte geben. Sollten Sie dennoch
                        Hilfe benötigen,
                        dann können Sie sich an uns wenden.
                    </p>

                    <h2 className="text-xl font-semibold text-gray-800 mb-4">Verarbeitete Datenarten</h2>
                    <p className="text-lg font-semibold text-gray-700 mb-4">
                        Kontaktdaten (z. B. E-Mail, Telefonnummern); Inhaltsdaten (z. B. Eingaben in Onlineformularen);
                        Nutzungsdaten (z. B. besuchte Webseiten, Interesse an Inhalten, Zugriffszeiten); Meta-,
                        Kommunikations- und Verfahrensdaten
                        (z. B. IP-Adressen, Zeitangaben, Identifikationsnummern, Einwilligungsstatus).
                    </p>

                    <h2 className="text-xl font-semibold text-gray-800 mb-4">Betroffene Personen</h2>
                    <p className="text-lg font-semibold text-gray-700 mb-4">
                        Nutzer (z. B. Webseitenbesucher, Nutzer von Onlinediensten).
                    </p>

                    <h2 className="text-xl font-semibold text-gray-800 mb-4">Zwecke der Verarbeitung</h2>
                    <p className="text-lg font-semibold text-gray-700 mb-4">
                        Kontaktanfragen und Kommunikation; Feedback (z. B. Sammeln von Feedback via Online-Formular);
                        Marketing.
                    </p>

                    <h2 className="text-xl font-semibold text-gray-800 mb-4">Rechtsgrundlagen</h2>
                    <p className="text-lg font-semibold text-gray-700 mb-4">
                        Berechtigte Interessen (Art. 6 Abs. 1 S. 1 lit. f) DSGVO).
                    </p>

                    <h2 className="text-xl font-semibold text-gray-800 mb-4">
                        Weitere Hinweise zu Verarbeitungsprozessen, Verfahren und Diensten
                    </h2>
                    <p className="text-lg font-semibold text-gray-700 mb-4">
                        <strong>LinkedIn:</strong> Soziales Netzwerk; Dienstanbieter: LinkedIn Ireland Unlimited
                        Company, Wilton Place,
                        Dublin 2, Irland; Rechtsgrundlagen: Berechtigte Interessen (Art. 6 Abs. 1 S. 1 lit. f) DSGVO);
                        Website:&nbsp;
                        <a
                            href="https://www.linkedin.com"
                            className="text-blue-600 underline"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            https://www.linkedin.com
                        </a>;
                        Datenschutzerklärung:&nbsp;
                        <a
                            href="https://www.linkedin.com/legal/privacy-policy"
                            className="text-blue-600 underline"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            https://www.linkedin.com/legal/privacy-policy
                        </a>;
                        Grundlage Drittlandübermittlung: EU-US Data Privacy Framework (DPF), Standardvertragsklauseln
                        (<a
                        href="https://legal.linkedin.com/dpa"
                        className="text-blue-600 underline"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        https://legal.linkedin.com/dpa
                    </a>);
                        Widerspruchsmöglichkeit (Opt-Out):&nbsp;
                        <a
                            href="https://www.linkedin.com/psettings/guest-controls/retargeting-opt-out"
                            className="text-blue-600 underline"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            https://www.linkedin.com/psettings/guest-controls/retargeting-opt-out
                        </a>;
                        Weitere Informationen: Wir sind gemeinsam mit LinkedIn Irland Unlimited Company für die Erhebung
                        (jedoch nicht die weitere Verarbeitung)
                        von Daten der Besucher, die zu Zwecken der Erstellung der „Page-Insights" (Statistiken) unserer
                        LinkedIn-Profile verantwortlich.
                    </p>
                    <p className="text-lg font-semibold text-gray-700 mb-4">
                        Zu diesen Daten gehören Informationen zu den Arten von Inhalten, die Nutzer sich ansehen oder
                        mit denen sie interagieren,
                        oder die von ihnen vorgenommenen Handlungen sowie Informationen über die von den Nutzern
                        genutzten Geräte
                        (z. B. IP-Adressen, Betriebssystem, Browsertyp, Spracheinstellungen, Cookie-Daten) und Angaben
                        aus dem Profil der Nutzer,
                        wie Berufsfunktion, Land, Branche, Hierarchieebene, Unternehmensgröße und Beschäftigungsstatus.
                        Datenschutzinformationen
                        zur Verarbeitung von Daten der Nutzer durch LinkedIn können den Datenschutzhinweisen von
                        LinkedIn entnommen werden:&nbsp;
                        <a
                            href="https://www.linkedin.com/legal/privacy-policy"
                            className="text-blue-600 underline"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            https://www.linkedin.com/legal/privacy-policy
                        </a>.
                    </p>
                    <p className="text-lg font-semibold text-gray-700 mb-4">
                        Wir haben mit LinkedIn Irland eine spezielle Vereinbarung abgeschlossen ("Page Insights Joint
                        Controller Addendum (the 'Addendum')",
                        <a
                            href="https://legal.linkedin.com/pages-joint-controller-addendum"
                            className="text-blue-600 underline"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            https://legal.linkedin.com/pages-joint-controller-addendum
                        </a>), in der insbesondere geregelt wird, welche Sicherheitsmaßnahmen LinkedIn beachten muss und
                        in der LinkedIn sich bereit erklärt hat,
                        die Betroffenenrechte zu erfüllen (d. h. Nutzer können z. B. Auskünfte oder Löschungsanfragen
                        direkt an LinkedIn richten).
                        Die Rechte der Nutzer (insbesondere auf Auskunft, Löschung, Widerspruch und Beschwerde bei
                        zuständiger Aufsichtsbehörde)
                        werden durch die Vereinbarungen mit LinkedIn nicht eingeschränkt. Die gemeinsame
                        Verantwortlichkeit beschränkt sich auf die Erhebung
                        der Daten durch und die Übermittlung an die Ireland Unlimited Company, ein Unternehmen mit Sitz
                        in der EU.
                        Die weitere Verarbeitung der Daten obliegt ausschließlich der Ireland Unlimited Company, was
                        insbesondere die Übermittlung der Daten
                        an die Muttergesellschaft LinkedIn Corporation in den USA betrifft.
                    </p>
                    <p className="text-lg font-semibold text-gray-700 mb-4">
                        <strong>Quelle:</strong>
                        <a
                            href="https://www.e-recht24.de"
                            className="text-blue-600 underline"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            https://www.e-recht24.de
                        </a>
                    </p>
                </div>


            </div>
            <div className="px-8 p-20">
                <Footer/>
            </div>
        </div>

    )
}
